import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Country } from '@utils/country';
import { CountrysService } from 'src/app/services/countrys.service';
import {
  Estados,
  occupation,
  economicActivity,
  pasCi,
} from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';
import { CasesService } from 'src/app/core/services/cases.service';
import { ActivatedRoute } from '@angular/router';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';

enum Texts {
  names = '11.Nombres',
  lastNames = '10.Apellidos',
  ciPassport = '12.Cédula de identidad / Pasaporte',
  nationality = '13.Nacionalidad *',
  gender = '16.Género',
  birthdate = '15.Fecha de nacimiento',
  placeOfBirth = '14.Lugar de nacimiento',
  economicActivity = '24.Actividad economica *',
  specificActivity = '25.Actividad especifica *',
  occupation = '23.Profesión / Ocupación',
  direction = '17.Dirección *',
  state = '18.Estado *',
  municipality = '19.Municipio *',
  parish = '20.Parroquia *',
  phone1 = '21.Telefono 1 *',
  phone2 = '22.Telefono 2',
  institutionReportingClient = '26.Cliente de la institución reportante *',
  riskLevel = '28.Nivel de riesgo LC/FT/FPADM *',
  employmentRelationship = '27.Relación laboral con la persona o institución reportante',
  pasCi = 'Cédula de identidad/Pasaporte',
}

@Component({
  selector: 'natural-form',
  templateUrl: './natural-form.component.html',
  styleUrls: ['./natural-form.component.scss'],
})
export class NaturalFormComponent implements OnInit {
  public Texts = Texts;
  @Input() form: FormGroup;
  @Input() est: any[];
  @Input() estMun: any[];
  @Input() mun: any[];
  @Input() munParr: any[];
  @Input() parr: any[];
  @Input() icase;
  @Output() formChange = new EventEmitter<FormGroup>();
  // countrys: Country[];
  countrys: string[];
  estados = Estados;
  occupatio = occupation;
  activity = economicActivity;
  pasCi = pasCi;
  typeOfPerson = ['V', 'E', 'P'];

  constructor(
    private countrysService: CountrysService,
    private readonly casesService: CasesService,
    private readonly route: ActivatedRoute,
    private readonly caseService: CaseService,
    private readonly dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.countrys = await this.countrysService.countries;
    this.getCase();
  }
  async confirmChanges() {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title:
            'Al alterar este dato, cambiara automáticamente información sensible',
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (re) => {});
  }
  changeCi() {
    if (this.form.value.nationality == 'E') {
      this.form.controls.pasCi.setValue(this.form.value.nationality);
    } else {
      this.form.controls.pasCi.setValue('V');
    }
    this.chCi();
  }
  changeNacionali() {
    console.log(this.form.value.pasCi);
    if (this.form.value.pasCi == 'V' || this.form.value.pasCi == 'P') {
      this.form.controls.nationality.setValue('V');
    } else {
      this.form.controls.nationality.setValue('E');
    }
    this.chCi();
  }

  riskLevels = [
    {
      name: 'Bajo',
      level: 'low',
    },
    {
      name: 'Moderado',
      level: 'moderate',
    },
    {
      name: 'Alto',
      level: 'high',
    },
  ];

  chCi() {
    //cambia la cedula
    let ci = this.form.value.ciPassport;
    if (ci != '') {
      ci = ci.split('');
      if (!this.includesLetter(ci)) {
        ci.splice(
          0,
          0,
          this.form.value.pasCi.toUpperCase() == 'P'
            ? 'V'
            : this.form.value.pasCi.toUpperCase()
        );
      } else {
        ci.splice(
          0,
          1,
          this.form.value.pasCi.toUpperCase() == 'P'
            ? 'V'
            : this.form.value.pasCi.toUpperCase()
        );
      }
      ci = ci.join('');
    } else {
      ci =
        this.form.value.pasCi.toUpperCase() == 'P'
          ? 'V'
          : this.form.value.pasCi.toUpperCase();
    }
    this.form.controls.ciPassport.setValue(ci);
    this.confirmChanges();
  }
  includesLetter(ci: any) {
    for (let type of this.typeOfPerson) {
      if (ci.includes(type)) {
        return ci.includes(type);
      }
    }
  }
  case;
  aditionalInformation;
  getCase() {
    this.caseService.getCase(this.icase).subscribe((res) => {
      this.case = res;
      this.aditionalInformation = res.additionalInformation;
    });
  }

  //cuando cambia el estado de el estado borra municipio y parroquia
  changeEstado(estad) {
    this.form.controls.municipality.setValue(undefined);
    this.form.controls.parish.setValue(undefined);
    this.mun = [];
    this.estMun = this.estados.filter((es) => {
      return es.estado == estad;
    });
    for (let e of this.estMun[0].municipio) {
      this.mun.push(e.municipio);
    }
  }
  //cuando cambia el estado de el municipio actualiza la tabla de parroquia
  changeMunicipio(mun) {
    if (this.estMun[0]) {
      this.munParr = this.estMun[0].municipio.filter((munici) => {
        return munici.municipio == mun;
      });
      this.parr = this.munParr[0].parroquias;
    }
  }
}
